import React, { Component } from "react";
import { Divider, Row, Layout, Button } from "antd";
import { Link } from "react-router-dom";
import ReactGA from "react-ga4";
import throttle from "lodash.throttle";
import PropTypes from "prop-types";
import BestCatsTable from "../../table/BestCatsTable";
import TierListTable from "../../table/TierListTable";
import {
  FacebookShareButton,
  RedditShareButton,
  TwitterShareButton,
  VKShareButton,
  FacebookIcon,
  RedditIcon,
  TwitterIcon,
  VKIcon,
} from "react-share";
import VenatusAd from "../../ads/VenatusAd";
import VenatusAdWithPlaceholder from "../../ads/VenatusAdWithPlaceholder";
import {
  VENATUS_DESKTOP_LEADERBOARD,
  VENATUS_MOBILE_LEADERBOARD,
  VENATUS_MOBILE_INCONTENT,
  VENATUS_RICH_MEDIA_WITH_STICKY_VERTICAL,
  VENATUS_RICH_MEDIA,
} from "../../utilities/constants";

const shareURL = "https://mygamatoto.com/galaxy-gals-tier-list";
const { Content } = Layout;

export const initGA = () => {
  ReactGA.initialize(
    "G-MX6GYDK28N"
    // , {
    //   gaAddress: "https://onestoppress.com/analytics.js"
    // }
  );
};

export const logPageView = () => {
  ReactGA.set({ page: window.location.pathname + window.location.search });
};

class GalaxyGals extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewportWidth: 0,
      compareCatsLevels: 30,
    };
  }
  componentDidMount() {
    this.saveViewportDimensions();
    window.addEventListener("resize", this.saveViewportDimensions);

    // initGA();
    // logPageView();

    document.title = "Galaxy Gals Tier List | Battle Cats Wiki for Cat Stats";
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.saveViewportDimensions);
  }

  saveViewportDimensions = throttle(() => {
    let adjustViewport;
    if (window.innerWidth < 636) {
      adjustViewport = 22;
    } else if (window.innerWidth < 948) {
      adjustViewport = 34;
    } else {
      adjustViewport = 46;
    }

    this.setState({
      viewportWidth: window.innerWidth - adjustViewport,
    });
  }, this.props.applyViewportChange);

  showModal = () => {
    this.setState({ isModalVisible: true });
  };

  handleCancel = () => {
    this.setState({ isModalVisible: false });
  };

  render() {
    const bestCats = [
      {
        key: "160-1",
        name: "Kalisa",
        number: "160-1",
        form: "Normal",
        rarity: "Uber Super Rare",
        level: 1,
        health: 3800,
        damage: 2750,
        range: 325,
        kb: 5,
        speed: 27,
        dps: 548,
        target: "Area",
        tba: "5.03",
        anim: "1.33",
        spawn: "64.53",
        cost: 4125,
        ability: "u1Against angelu2: b1Massive Damageb2 (inflicts 3.0x damage)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "107-1",
        name: "Kai",
        number: "107-1",
        form: "Normal",
        rarity: "Uber Super Rare",
        level: 1,
        health: 10750,
        damage: 7775,
        range: 175,
        kb: 2,
        speed: 8,
        dps: 740,
        target: "Area",
        tba: "10.50",
        anim: "2.53",
        spawn: "71.20",
        cost: 3990,
        ability:
          "u1Against floatingu2: b1Resistantb2 (only takes 0.25x damage) \nu1General Abilitiesu2: b1Surviveb2 (100% chance to survive a lethal strike)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "077-1",
        name: "Thundia",
        number: "077-1",
        form: "Normal",
        rarity: "Uber Super Rare",
        level: 1,
        health: 2000,
        damage: 3138,
        range: 410,
        kb: 5,
        speed: 5,
        dps: 238,
        target: "Area",
        tba: "13.23",
        anim: "3.00",
        spawn: "106.00",
        cost: 4410,
        ability: "u1Against redu2: b1Massive Damageb2 (inflicts 3.0x damage)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "076-1",
        name: "Windy",
        number: "076-1",
        form: "Normal",
        rarity: "Uber Super Rare",
        level: 1,
        health: 2000,
        damage: 3138,
        range: 420,
        kb: 6,
        speed: 6,
        dps: 230,
        target: "Area",
        tba: "13.60",
        anim: "2.70",
        spawn: "102.27",
        cost: 4425,
        ability:
          "u1Against floatingu2: b1Massive Damageb2 (inflicts 3.0x damage)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "450-1",
        name: "Headmistress Jeanne",
        number: "450-1",
        form: "Normal",
        rarity: "Legendary Rare",
        level: 1,
        health: 8000,
        damage: 1650,
        range: 400,
        kb: 4,
        speed: 20,
        dps: 570,
        target: "Area",
        tba: "2.90",
        anim: "1.60",
        spawn: "116.53",
        cost: 4830,
        ability:
          "u1Against red, floatingu2: b1Insane Damageb2 (inflicts 5.0x damage) \r\nu1General Abilitiesu2: b1Long Distanceb2 (Effective range 200~550)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "352-1",
        name: "Twinstars",
        number: "352-1",
        form: "Normal",
        rarity: "Uber Super Rare",
        level: 1,
        health: 2750,
        damage: 2325,
        range: 350,
        kb: 4,
        speed: 22,
        dps: 578,
        target: "Area",
        tba: "4.03",
        anim: "0.67",
        spawn: "71.20",
        cost: 3900,
        ability:
          "u1Against black, alienu2: b1Massive Damageb2 (inflicts 3.0x damage) \nu1General Abilitiesu2: b1Multi-hit attackb2 (Attacks thrice consecutively)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "108-1",
        name: "Coppermine",
        number: "108-1",
        form: "Normal",
        rarity: "Uber Super Rare",
        level: 1,
        health: 3175,
        damage: 2650,
        range: 335,
        kb: 3,
        speed: 7,
        dps: 420,
        target: "Area",
        tba: "6.30",
        anim: "3.33",
        spawn: "65.87",
        cost: 3720,
        ability:
          "u1Against floatingu2: b1Freezeb2 (50% chance to freeze for 4.67s)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "503-1",
        name: "Myrcia",
        number: "503-1",
        form: "Normal",
        rarity: "Uber Super Rare",
        level: 1,
        health: 4500,
        damage: 3825,
        range: 330,
        kb: 4,
        speed: 10,
        dps: 475,
        target: "Area",
        tba: "8.03",
        anim: "3.07",
        spawn: "91.20",
        cost: 4260,
        ability:
          "u1Against whiteu2: b1Dodgeb2 (30% chance to dodge for 2.0s) \nu1General Abilitiesu2: b1Wave attackb2 (100% chance to perform a Lv.2 Shockwave attack (Range: 532)) b1Multi-hit attackb2 (Attacks twice consecutively)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "106-1",
        name: "Kuu",
        number: "106-1",
        form: "Normal",
        rarity: "Uber Super Rare",
        level: 1,
        health: 3500,
        damage: 5850,
        range: 380,
        kb: 5,
        speed: 13,
        dps: 325,
        target: "Area",
        tba: "17.97",
        anim: "2.00",
        spawn: "131.20",
        cost: 4200,
        ability:
          "u1Against red, blacku2: b1Strongb2 (inflicts 1.5x damage, takes only 0.5x damage)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "620-1",
        name: "Lilin",
        number: "620-1",
        form: "Normal",
        rarity: "Uber Super Rare",
        level: 1,
        health: 5250,
        damage: 2875,
        range: 350,
        kb: 3,
        speed: 11,
        dps: 460,
        target: "Area",
        tba: "6.23",
        anim: "2.13",
        spawn: "84.53",
        cost: 3900,
        ability:
          "u1Against angel, akuu2: b1Strongb2 (inflicts 1.5x damage, takes only 0.5x damage) \nu1General Abilitiesu2: b1Shield Piercingb2 (100% chance to break Aku shields)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
    ];

    const tierList = [
      {
        tier: "SS",
        cats: [],
      },
      {
        tier: "S",
        cats: [],
      },
      {
        tier: "A+",
        cats: [],
      },
      {
        tier: "A",
        cats: [{ name: "Kalisa", number: "160-1" }],
      },
      {
        tier: "B+",
        cats: [
          { name: "Kai", number: "107-1" },
          { name: "Thundia", number: "077-1" },
          { name: "Windy", number: "076-1" },
          { name: "Headmistress Jeanne", number: "450-1" },
        ],
      },
      {
        tier: "B",
        cats: [],
      },
      {
        tier: "B-",
        cats: [{ name: "Twinstars", number: "352-1" }],
      },
      {
        tier: "C+",
        cats: [{ name: "Coppermine", number: "108-1" }],
      },
      {
        tier: "C",
        cats: [
          { name: "Myrcia", number: "503-1" },
          { name: "Kuu", number: "106-1" },
          { name: "Lilin", number: "620-1" },
        ],
      },
      {
        tier: "D",
        cats: [],
      },
    ];

    return (
      <div>
        <div className="pagetitle">
          <h1 style={{ padding: "10px 0 0 0", marginBottom: "6px" }}>
            Tier List
          </h1>
          <Divider style={{ margin: "0 0 0 0", padding: "0 0 0 0" }} />
        </div>
        <Layout style={{ padding: "0 12px 0 12px", background: "white" }}>
          <Content className="flexible-width">
            <Row style={{ padding: "16px 0 0 0" }}>
              <div>
                {this.state.viewportWidth > 1024 ? (
                  <VenatusAdWithPlaceholder
                    placementId={VENATUS_DESKTOP_LEADERBOARD}
                  />
                ) : (
                  ""
                  // <VenatusAdWithPlaceholder
                  //   placementId={VENATUS_MOBILE_LEADERBOARD}
                  // />
                )}
                <h2 style={{ marginTop: "12px", fontSize: "24px" }}>
                  The Galaxy Gals Tier List
                </h2>
                <p></p>
                <div>
                  Tier list for The Galaxy Gals, listed from worst to best.
                  Credit goes to the Tier List on the{" "}
                  <a href="https://www.reddit.com/r/battlecats/wiki/index">
                    Reddit r/battlecats Wiki
                  </a>
                  &nbsp;under the Cat Guides.
                  <p></p>
                  <i>Last updated: 17 October 2021</i>
                </div>
              </div>
            </Row>

            <Row style={{ margin: "16px 0 0 0" }}>
              <FacebookShareButton
                url={"http://mygamatoto.com" + window.location.pathname}
                style={{ marginRight: "0.25rem" }}
              >
                <FacebookIcon size={32} round />
              </FacebookShareButton>
              <TwitterShareButton
                url={"http://mygamatoto.com" + window.location.pathname}
                title="MyGamatoto - The Galaxy Gals Tier List"
                style={{ marginRight: "0.25rem" }}
              >
                <TwitterIcon size={32} round />
              </TwitterShareButton>
              <RedditShareButton
                url={"http://mygamatoto.com" + window.location.pathname}
                style={{ marginRight: "0.25rem" }}
              >
                <RedditIcon size={32} round />
              </RedditShareButton>
              <VKShareButton
                url={"http://mygamatoto.com" + window.location.pathname}
                title="MyGamatoto - The Galaxy Gals Tier List"
                style={{ marginRight: "0.25rem" }}
              >
                <VKIcon size={32} round />
              </VKShareButton>
            </Row>
            {this.state.viewportWidth > 1024 ? (
              ""
            ) : (
              <div style={{ margin: "10px 0 0 0" }}>
                <div
                  class="vm-placement"
                  id="vm-av"
                  data-format="isvideo"
                ></div>
              </div>
            )}
            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  10.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[9].number +
                      ".png"
                    }
                    alt={bestCats[9].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[9].number.slice(0, 3) +
                          "/" +
                          bestCats[9].name
                        }
                      >
                        {bestCats[9].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  This mad researcher experimented on her own classmates to
                  synthesize the vile Mateki elixir. Strong vs Angels &amp; Aku,
                  with Piercing attacks.
                  <p></p>
                  <b>Other forms: </b>Lilin π<p></p>
                  <b>Pros: </b>One of the few cats with 100% Shield Piercing
                  ability.
                  <p></p>
                  <b>Cons: </b>Poor base stats. Poor range also makes it hard
                  for her to exploit her Shield Piercing ability against
                  longer-ranged Aku enemies, like the{" "}
                  <Link to={"/enemyinfo/558/Fallen%20Bear"}>Fallen Bear</Link>.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter((item) => item.name === "Lilin")}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            {/* <InPageAdComponent
              style={{ marginTop: "8px" }}
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="8579060881"
            /> */}
            {/* <div id="waldo-tag-14680"></div> */}
            <div style={{ paddingTop: "1em" }} />
            {this.state.viewportWidth > 1024 ? (
              <span>
                <VenatusAdWithPlaceholder
                  placementId={VENATUS_DESKTOP_LEADERBOARD}
                />
              </span>
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_INCONTENT}
              />
            )}
            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  9.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[8].number +
                      ".png"
                    }
                    alt={bestCats[8].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[8].number.slice(0, 3) +
                          "/" +
                          bestCats[8].name
                        }
                      >
                        {bestCats[8].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>Zealous user of strange witchcraft to
                  control her staff for great damage from a distance. Strong
                  against Black/Red enemies. (Area Attack)
                  <p></p>
                  <b>Other forms: </b>Kuu, type γ, Divine Kuu
                  <p></p>
                  <b>Pros: </b>Decent base stats.
                  <p></p>
                  <b>Cons: </b>Severe tendency to miss due to her slow attacks.
                  This means her strong attacks are virtually useless against
                  most Black enemies, which tend to be pushers.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter((item) => item.name === "Kuu")}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  8.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[7].number +
                      ".png"
                    }
                    alt={bestCats[7].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[7].number.slice(0, 3) +
                          "/" +
                          bestCats[7].name
                        }
                      >
                        {bestCats[7].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Money couldn't buy happiness, but it bought a small arsenal
                  that very much brings a smile to her face. Wave Attacks, might
                  dodge Traitless enemy attacks.
                  <p></p>
                  <b>Other forms: </b>Myrcia, type ξ, Divine Myrcia
                  <p></p>
                  <b>Pros: </b>As Traitless enemies tend to be peons like{" "}
                  <Link to={"/enemyinfo/002/Those%20Guys"}>Those Guys</Link> and{" "}
                  <Link to={"/enemyinfo/000/Doge"}>Doge</Link>, her ability to
                  Dodge is easily triggered by them, rendering her invincible
                  against Traitless enemies for 2 seconds.
                  <p></p>
                  <b>Cons: </b>Her wave ability knocks out most peons, making it
                  hard to safely trigger her Dodge ability. Her multi-hit attack
                  also causes her to kill off or knockback frontline enemies on
                  her first hit, causing her second hit to miss and failing to
                  trigger her wave attack. Really a great example of abilities
                  working against each other.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter((item) => item.name === "Myrcia")}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  7.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[6].number +
                      ".png"
                    }
                    alt={bestCats[6].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[6].number.slice(0, 3) +
                          "/" +
                          bestCats[6].name
                        }
                      >
                        {bestCats[6].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Magicial beauty powered by her staff Releases beams of light
                  (Area Attack) Might freeze floating enemies.
                  <p></p>
                  <b>Other forms: </b>Coppermine, type κ, Divine Coppermine
                  <p></p>
                  <b>Pros: </b>True form grants longer range and a higher chance
                  (75%) of Freezing Floating enemies.
                  <p></p>
                  <b>Cons: </b>Poor overall stats. Can be easily replaced by
                  other anti-Floating controllers like the{" "}
                  <Link to={"/catinfo/053/Necro-Dancer%20Cat"}>
                    Necro-Dancer Cat
                  </Link>
                  .
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Coppermine"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            {/* <InPageAdComponent
              style={{ marginTop: "8px" }}
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="8579060881"
            /> */}
            <div style={{ paddingTop: "1em" }} />
            {this.state.viewportWidth > 1024 ? (
              <span>
                <VenatusAdWithPlaceholder
                  placementId={VENATUS_DESKTOP_LEADERBOARD}
                />
              </span>
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_INCONTENT}
              />
            )}
            <Row style={{ padding: "16px 0 0 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  6.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[5].number +
                      ".png"
                    }
                    alt={bestCats[5].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[5].number.slice(0, 3) +
                          "/" +
                          bestCats[5].name
                        }
                      >
                        {bestCats[5].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>The two purehearted sisters, Cici and
                  Koma. Divine breath controls their mighty mecha claws. Massive
                  area damage to Aliens/Black.
                  <p></p>
                  <b>Other forms: </b>Twinstars, type Φ, Divine Twinstars
                  <p></p>
                  <b>Pros: </b>Decent crowd controller against Black and Alien
                  enemies, with their frequent multi-hit attacks. High speed and
                  decent recharging time allows them to be used as suicide
                  bombers, though they do need to be somewhat protected to
                  prevent them from getting knocked back before their attack.
                  <p></p>
                  <b>Cons: </b>If an anti-Black suicide bomber is ever needed,
                  just use{" "}
                  <Link to={"/catinfo/072/Immortal%20Yukimura"}>
                    Immortal Yukimura
                  </Link>
                  .
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Twinstars"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  5.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[4].number +
                      ".png"
                    }
                    alt={bestCats[4].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[4].number.slice(0, 3) +
                          "/" +
                          bestCats[4].name
                        }
                      >
                        {bestCats[4].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>Chairwoman of the Cyber Academy, respected
                  by all. Summons ethereal spears to punish bad students. Insane
                  damage to Red/Floating. (Long-Range/Area)
                  <p></p>
                  <b>Other forms: </b>Headmistress Jeanne ψ<p></p>
                  <b>Pros: </b>Outstanding damage dealer against Red and
                  Floating enemies. With her Insane Damage ability and short
                  time between attacks, her DPS is off the charts against them.
                  Forget <Link to={"/catinfo/077/Thundia"}>Thundia</Link> and{" "}
                  <Link to={"/catinfo/306/B.C.S.%20Tigerclaw"}>
                    B.C.S. Tigerclaw
                  </Link>{" "}
                  — no other cat comes close.
                  <p></p>
                  <b>Cons: </b>While her Long Distance ability grants her extra
                  range, this comes at a cost of making her useless against
                  short-ranged pushers like{" "}
                  <Link to={"/enemyinfo/205/Capy"}>Capy</Link>. Longer-ranged
                  enemies like{" "}
                  <Link to={"/enemyinfo/185/Professor%20A."}>Professor A.</Link>{" "}
                  also tend to knock her back before she's able to land an
                  attack.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Headmistress Jeanne"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            {/* <InPageAdComponent
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="8579060881"
            /> */}
            <div style={{ paddingTop: "1em" }} />
            {this.state.viewportWidth > 1024 ? (
              <span>
                <VenatusAdWithPlaceholder
                  placementId={VENATUS_DESKTOP_LEADERBOARD}
                />
              </span>
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_INCONTENT}
              />
            )}
            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  4.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[3].number +
                      ".png"
                    }
                    alt={bestCats[3].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[3].number.slice(0, 3) +
                          "/" +
                          bestCats[3].name
                        }
                      >
                        {bestCats[3].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>A galaxy girl who manipulates wind. Her
                  vacuum cannon cleans enemies from a distance Massive damage to
                  Floating enemies. (Area Attack)
                  <p></p>
                  <b>Other forms: </b>Windy, type α, Divine Windy
                  <p></p>
                  <b>Pros: </b>Pretty much the anti-floating version of{" "}
                  <Link to={"/catinfo/077/Thundia"}>Thundia</Link>.<p></p>
                  <b>Cons: </b>Again, same as{" "}
                  <Link to={"/catinfo/077/Thundia"}>Thundia</Link>. The one
                  upside is that she outranges most Floating enemies, except
                  rare ones like the{" "}
                  <Link to={"/enemyinfo/080/Crazed%20Bird%20Cat"}>
                    Crazed Bird Cat
                  </Link>
                  .
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter((item) => item.name === "Windy")}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  3.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[2].number +
                      ".png"
                    }
                    alt={bestCats[2].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[2].number.slice(0, 3) +
                          "/" +
                          bestCats[2].name
                        }
                      >
                        {bestCats[2].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>A galaxy girl who can manipulate
                  electricity. Brings down bolts from a distance. Massive damage
                  to Red enemies. (Area Attack)
                  <p></p>
                  <b>Other forms: </b>Thundia, type β, Divine Thundia
                  <p></p>
                  <b>Pros: </b>Her true form is the strongest anti-red attacker
                  in the game with the highest damage, with decent range.{" "}
                  <Link to={"/catinfo/306/B.C.S.%20Tigerclaw"}>
                    B.C.S. Tigerclaw
                  </Link>{" "}
                  comes in at a close second, with a slightly shorter time
                  between attacks but at the cost of a much longer recharging
                  time.
                  <p></p>
                  <b>Cons: </b>Her long foreswing is also an issue. While she
                  does well enough against most red enemies, with her average
                  health, she remains vulnerable to longer-ranged enemies like{" "}
                  <Link to={"/enemyinfo/185/Professor%20A."}>Professor A.</Link>{" "}
                  and{" "}
                  <Link to={"/enemyinfo/148/Li'l%20Nyandam"}>Li'l Nyandam</Link>
                  .
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Thundia"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  2.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[1].number +
                      ".png"
                    }
                    alt={bestCats[1].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[1].number.slice(0, 3) +
                          "/" +
                          bestCats[1].name
                        }
                      >
                        {bestCats[1].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>Airheaded girl riding her machine pig
                  "Tonton". Fires powerful point blank beams (Area Attack)
                  Reduced damage from Floating, Survives Once.
                  <p></p>
                  <b>Other forms: </b>Kai, type μ, Divine Kai
                  <p></p>
                  <b>Pros: </b>The best anti-floating tanker. Does well in every
                  lineup, with her Pork on Rice combo that gives a small boost
                  to defense. True form doubles her health and grants her
                  knockback immunity, making her even better as a tanker.
                  <p></p>
                  <b>Cons: </b>Tends to miss due to having a long foreswing.
                  With her short range and long time between attacks, her
                  ability to survive with 1 hp left is usually useless...but not
                  always. Sometimes stalling an enemy for an extra millisecond
                  could be all it takes to win.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter((item) => item.name === "Kai")}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            {/* <InPageAdComponent
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="8579060881"
            /> */}
            <div style={{ paddingTop: "1em" }} />
            {this.state.viewportWidth > 1024 ? (
              <span>
                <VenatusAdWithPlaceholder
                  placementId={VENATUS_DESKTOP_LEADERBOARD}
                />
              </span>
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_INCONTENT}
              />
            )}
            <Row style={{ padding: "0px 0 0px 0" }}>
              <Row style={{ padding: "0px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  1.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[0].number +
                      ".png"
                    }
                    alt={bestCats[0].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[0].number.slice(0, 3) +
                          "/" +
                          bestCats[0].name
                        }
                      >
                        {bestCats[0].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>Almost obliterated her school on the first
                  day of class with her sword's dark magic. Massive damage
                  against Angels. (Area Attack)
                  <p></p>
                  <b>Other forms: </b>Kalisa, type χ, Divine Kalisa
                  <p></p>
                  <b>Pros: </b>One of the strongest anti-angel offensive units,
                  with her DPS being off the charts compared to most anti-angel
                  Ubers due to her frequent time between attacks. Her fast speed
                  allows her to be a great suicide bomber if timed properly,
                  getting a few crucial hits on strong Angel enemies.
                  <p></p>
                  <b>Cons: </b>Range still falls short against several Angel
                  enemies, such as{" "}
                  <Link to={"/enemyinfo/125/Angelic%20Sleipnir"}>
                    Angelic Sleipnir
                  </Link>
                  ,{" "}
                  <Link to={"/enemyinfo/379/Winged%20Pigge"}>Winged Pigge</Link>{" "}
                  and <Link to={"/enemyinfo/340/Cala%20Maria"}>Cala Maria</Link>
                  .
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter((item) => item.name === "Kalisa")}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            {/* <InPageAdComponent
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="8579060881"
            /> */}
            <div style={{ paddingTop: "1em" }} />
            {this.state.viewportWidth > 1024 ? (
              <span>
                <VenatusAdWithPlaceholder
                  placementId={VENATUS_DESKTOP_LEADERBOARD}
                />
              </span>
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_INCONTENT}
              />
            )}
            <Row style={{ padding: "6px 0 6px 0", marginTop: "6px" }}>
              <Divider orientation="left" style={{ fontSize: "24px" }}>
                Tier List
              </Divider>
              <TierListTable
                selectedCats={tierList}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "6px 0 6px 0" }}>
              <Divider />
              <h3>Compare all 10 cats below</h3>
              <BestCatsTable
                selectedCats={bestCats}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row
              style={{
                padding: "24px 20px 18px 20px",
                backgroundColor: "#ffa50038",
                textAlign: "center",
                margin: "0 0 8px 0",
              }}
            >
              <div style={{ fontSize: "16px" }}>
                Want to compare the stats of any cat in The Battle Cats?
              </div>
              <Divider
                style={{ backgroundColor: "orange", marginTop: "12px" }}
              ></Divider>
              <Button href="/comparecats" size="large">
                Compare more cats
              </Button>
            </Row>
          </Content>
        </Layout>
        {/* <HorizontalAdPopup
          dataAdClient="ca-pub-1920730948516638"
          dataAdSlot="3694383950"
        ></HorizontalAdPopup> */}
        {/* <div id="waldo-tag-14678"></div> */}
        {this.state.viewportWidth > 1024 ? (
          <div>
            <VenatusAd
              placementId={VENATUS_RICH_MEDIA_WITH_STICKY_VERTICAL}
              style={{ display: "none" }}
            />
          </div>
        ) : (
          <div>
            <VenatusAd
              placementId={VENATUS_RICH_MEDIA}
              style={{ display: "none" }}
            />
          </div>
        )}
      </div>
    );
  }
}

export default GalaxyGals;

GalaxyGals.propTypes = {
  applyViewportChange: PropTypes.number,
};

GalaxyGals.defaultProps = {
  applyViewportChange: 250,
};



// WEBPACK FOOTER //
// ./src/components/content/tierlist/GalaxyGals.js